defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Ribbon',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/NumberGames/Scripts/Components/Shared/Svg/Svg',
  ],
  function (m, Svg) {
    let originalTitle = null;

    // Context:
    const Ribbon = function (args) {
      const subTitle = args.subtitle;
      const asInput = args.asInput;
      let title = args.title;
      let placeholder = args.placeholder;
      const $editButton = args.$editButton;

      var onFocus = function () {
        if (title === placeholder) return;
        this.select();
      };

      var onInput = function () {
        title(this.value);
      };

      const onBlur = () => {
        if (!title?.()?.length > 0) {
          title(originalTitle());
        }

        if (placeholder && title()?.length === 0) {
          title(null);
        }
      };

      const onKeyDown = (event) => {
        if (event.which === 13) {
          event.preventDefault();
          event.target.blur();
        }
      };

      if (originalTitle === null) {
        originalTitle = title;
      }

      if (!title) {
        title = args.title;
      }
      if (!placeholder) {
        placeholder = args.placeholder;
      }

      var renderElement = function () {
        if (!title && !placeholder) return null;
        if (asInput) {
          const value = () => {
            if (placeholder && title() === null) {
              return placeholder;
            }

            return title();
          };
          return m('input.play-together__ribbon-title', {
            value: value(),
            onfocus: onFocus,
            oninput: onInput,
            onblur: onBlur,
            onkeydown: onKeyDown
          });
        }

        let titleValue = typeof title === 'function' ? title() : title;

        if (titleValue && titleValue.length > 22) {
          const titleSegments = titleValue.split(' ');
          const segmentsCount = titleSegments.length;
          const firstHalf = Math.round(segmentsCount / 2);
          titleValue = [
            titleSegments.slice(0, firstHalf).join(' '),
            m('br'),
            titleSegments.slice(firstHalf, segmentsCount).join(' ')
          ];
        }

        return m('.play-together__ribbon-title', titleValue);
      };

      const className = () => {
        let name = 'play-together__ribbon';

        if (title) {
          const titleValue = typeof title === 'function' ? title() : title;

          if (!asInput && titleValue && titleValue.length > 22) {
            name += ' play-together__ribbon--with-long-name';
          }
        }

        return name;
      };

      // Return:
      return m('div', {
        class: className()
      }, [
        m(Svg, { classNames: 'play-together__ribbon--left icon', src: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#ribbon-left' }),
        m('.play-together__ribbon-content', [
          m('.play-together__ribbon-content-inner', [
            renderElement(title),
            subTitle ? m('.play-together__ribbon-subtitle', subTitle) : null
          ]),
          $editButton
        ]),
        m(Svg, { classNames: 'play-together__ribbon--right icon', src: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#ribbon-right' })
      ]);
    };

    // Public functions:
    return Ribbon;
  });
